<div class="material-lines-panel" *ngIf="materials.length > 0">
  <h3>{{ 'CCR.DETAILS.MATERIAL_LINES' | translate }}</h3>

  <div class="row cell headings hide-xs">
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.PACKING' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.STATUS' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.LOGISTIC_VAR' | translate }}
    </div>
    <ng-container *ngIf="containsLoadedQuantities">
      <div class="col-md">
        {{"ORDERS.MATERIAL.LABELS.QTY_LOADED" | translate}}
      </div>
      <div class="col-md">
        {{"ORDERS.MATERIAL.LABELS.QTY_UNLOADED" | translate}}
      </div>
      <div class="col-md">
        {{"ORDERS.MATERIAL.LABELS.QTY_DIFFERENCE" | translate}}
      </div>
    </ng-container>
    <ng-container *ngIf="!containsLoadedQuantities">
      <div class="col-md">
        {{ 'ORDERS.MATERIAL.LABELS.QTY' | translate }}
      </div>
    </ng-container>
    <div class="col-md"></div>
  </div>

  <div class="hr-accent no_margin_bottom hide-xs"></div>

  <div *ngFor="let material of materials; index as i" class="striped" [ngClass]="{ readonly: readonly }">
    <div class="material_line" *ngIf="material.type === 'packing' || material.type === 'combination'">
      <div class="col-md packingType">
        <div class="connector" *ngIf="showAsCombination(material)">
          <app-connector [height]="connectorHeight" [width]="connectorWidth"></app-connector>
        </div>
        <eps-select
          [options]="definitions.packing.type"
          [value]="material.packingId"
          readonly
          label="ORDERS.MATERIAL.LABELS.PACKING"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.packing.status"
          [value]="material.packingStatus"
          readonly
          label="ORDERS.MATERIAL.LABELS.STATUS"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.order.logisticsVarietyPacking"
          [value]="material.logisticsVarietyPacking"
          readonly
          label="ORDERS.MATERIAL.LABELS.LOGISTIC_VAR"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <ng-container *ngIf="containsLoadedQuantities">
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_LOADED"
            [labelPosition]="labelPosition"
          >
            {{ material.loaded?.packingQuantity }}
          </eps-label-body>
        </div>
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_UNLOADED"
            [labelPosition]="labelPosition"
          >
            {{ material.unloaded?.packingQuantity }}
          </eps-label-body>
        </div>
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_DIFFERENCE"
            [labelPosition]="labelPosition"
          >
            {{ material.difference?.packingQuantity }}
          </eps-label-body>
        </div>
      </ng-container>
      <ng-container *ngIf="!containsLoadedQuantities">
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY"
            [labelPosition]="labelPosition"
          >
            {{ material.packingQuantity }}
          </eps-label-body>
        </div>
      </ng-container>
      <div class="col-md icon-buttons">
        <ng-container *ngIf="!readonly">
          <i class="fa fa-2x fa-pencil edit" aria-hidden="true" (click)="editMaterialClicked.emit(material)"></i>
          <i class="fa fa-2x fa-trash-o remove" aria-hidden="true" (click)="removeMaterialClicked.emit(material)"></i>
        </ng-container>
      </div>
    </div>

    <div class="material_line" [ngClass]="{ combination: material.type === 'combination' }" *ngIf="showPallet(material)">
      <div class="col-md">
        <eps-select
          [options]="definitions.pallet.type"
          [value]="material.palletId"
          readonly
          label="ORDERS.MATERIAL.LABELS.TYPES.PALLET"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.packing.status"
          [value]="material.packingStatus"
          readonly
          label="ORDERS.MATERIAL.LABELS.STATUS"
          [labelPosition]="labelPosition"
          *ngIf="material.type === 'pallet'"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.order.logisticsVarietyPacking"
          [value]="material.logisticsVarietyPacking"
          readonly
          label="ORDERS.MATERIAL.LABELS.LOGISTIC_VAR"
          [labelPosition]="labelPosition"
          *ngIf="material.type === 'pallet'"
        ></eps-select>
      </div>
      <ng-container *ngIf="containsLoadedQuantities">
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_LOADED"
            [labelPosition]="labelPosition"
          >
            {{ material.loaded?.numberOfPallets }}
          </eps-label-body>
        </div>
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_UNLOADED"
            [labelPosition]="labelPosition"
          >
            {{ material.unloaded?.numberOfPallets }}
          </eps-label-body>
        </div>
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY_DIFFERENCE"
            [labelPosition]="labelPosition"
          >
            {{ material.difference?.numberOfPallets }}
          </eps-label-body>
        </div>
      </ng-container>
      <ng-container *ngIf="!containsLoadedQuantities">
        <div class="col-md">
          <eps-label-body
            label="ORDERS.MATERIAL.LABELS.QTY"
            [labelPosition]="labelPosition"
          >
            {{ material.numberOfPallets }}
          </eps-label-body>
        </div>
      </ng-container>
      <div class="col-md icon-buttons">
        <div *ngIf="material.type !== 'combination' && !readonly">
          <i class="fa fa-2x fa-pencil edit" aria-hidden="true" (click)="editMaterialClicked.emit(material)"></i>
          <i class="fa fa-2x fa-trash-o remove" aria-hidden="true" (click)="removeMaterialClicked.emit(material)"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="hr-accent"></div>

  <div class="row epp" *ngIf="maxEpp && !containsLoadedQuantities">
    <div class="col-4 col-md-2">
      <span class="bold">{{ 'ORDERS.MATERIAL.LABELS.NR_OF_PFQS' | translate }}</span>
    </div>
    <div class="col-2 col-md-1">{{ loadedEpp }} / {{ maxEpp }}</div>
    <div class="col-6 col-md-9 loadedBar">
      <span class="loaded" [ngStyle]="loadedStyle" [ngClass]="{ normal: loadedEpp <= maxEpp, overloaded: loadedEpp > maxEpp }">
        <span *ngIf="fullTruck && loadedEpp === maxEpp">{{ 'ORDERS.MATERIAL.LABELS.FULL' | translate }}</span>
        <span *ngIf="loadedEpp > maxEpp">{{ 'ORDERS.MATERIAL.LABELS.OVERLOADED' | translate }}</span>
      </span>
      <span class="total" [ngStyle]="notLoadedStyle"></span>
    </div>
  </div>
</div>
